"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordPresentationDateRangeType = void 0;
var RecordPresentationDateRangeType;
(function (RecordPresentationDateRangeType) {
    RecordPresentationDateRangeType["PAST_1_DAY"] = "PAST_1_DAY";
    RecordPresentationDateRangeType["PAST_1_WEEK"] = "PAST_1_WEEK";
    RecordPresentationDateRangeType["PAST_1_MONTH"] = "PAST_1_MONTH";
    RecordPresentationDateRangeType["PAST_3_MONTHS"] = "PAST_3_MONTHS";
    RecordPresentationDateRangeType["PAST_1_YEAR"] = "PAST_1_YEAR";
    RecordPresentationDateRangeType["YEAR_TO_DATE"] = "YEAR_TO_DATE";
    RecordPresentationDateRangeType["ALL_TIME"] = "ALL_TIME";
})(RecordPresentationDateRangeType || (exports.RecordPresentationDateRangeType = RecordPresentationDateRangeType = {}));
